import React from "react";

//import { toBase64 } from "../../../utilities/base64";
//import IFrameDisplay from "../Display/IFrameDisplay";
//import tokenStorage from "../../../services/tokenStorage";

const service = "https://pdf-tools.premierit.co.uk/pdf/viewer/v2";

export default function PdfViewer({ src }) {
    //Placeholder till authentication is implemented
    return "Preview not available";

    /*     const srcEncoded = toBase64(src);
    const url = `${service}?src=${srcEncoded}`;

    const customHeaders = {
        Authorization: `Bearer ${tokenStorage.getAuthToken()}`,
    };

    return (
        <div style={{ width: "100%", height: "600px" }}>
            <IFrameDisplay url={url} headers={customHeaders} />
        </div>
    ); */
}
